import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { FormLodI } from 'src/app/interfaces/lod-form.interface';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LodService {
  constructor(private http: HttpClient) { }

  private url = environment.url;

  getOneForm(id: string) {
    let url = this.url + 'forms/form-info/' + id;
    return this.http.get<BackendResponse>(url).pipe(
      map((data) => data.result as FormLodI),
      catchError((error) => handleError(error))
    );
  }

  getAllCamionetas() {
    let url = this.url + 'vehiculos_road'

    return this.http.get<BackendResponse>(url).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }


  insertPdf(form: any) {
    const direction = `${this.url}pdf_log`;
    return this.http.post<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }

  sendMail(form: any) {
    const direction = this.url + 'forms/enviarEmails';
    return this.http
      .post<BackendResponse>(direction, form)
      .pipe(catchError((e) => handleError(e)));
  }

  sendMailManual(form: any) {
    const direction = this.url + 'ma-hallazgos/enviarEmails/manual';
    return this.http
      .post<BackendResponse>(direction, form)
      .pipe(catchError((e) => handleError(e)));
  }


}
